// src/components/view/ViewPageMediaRenderer.tsx
// ✅ ATUALIZADO: Ignora imagens antigas (localhost), renderiza apenas Cloudinary

import React from 'react';
import './ViewPageMediaRenderer.css';
import { ZoomIn } from 'lucide-react';
import { GraiaAudioPlayer } from '../common/GraiaAudioPlayer';

interface ViewPageMediaRendererProps {
    imageUrl?: string | null;
    audioUrl?: string | null;
    onImageClick?: (url: string) => void;
}

export const ViewPageMediaRenderer: React.FC<ViewPageMediaRendererProps> = ({
    imageUrl,
    audioUrl,
    onImageClick
}) => {
    // ✅ NOVO: Ignorar imagens antigas (localhost)
    const isCloudinaryImage = imageUrl && imageUrl.includes('cloudinary.com');
    const isCloudinaryAudio = audioUrl && audioUrl.includes('cloudinary.com');

    // Se não tem mídia do Cloudinary, não renderiza nada
    if (!isCloudinaryImage && !isCloudinaryAudio) {
        return null;
    }

    return (
        <div className="vpmr-container">
            {/* ✅ IMAGEM REDUZIDA COM ZOOM - só do Cloudinary */}
            {isCloudinaryImage && (
                <div
                    className="vpmr-image-wrapper"
                    onClick={(e) => e.stopPropagation()}
                >
                    <img
                        src={imageUrl}
                        alt="Card"
                        className="vpmr-image"
                        onClick={(e) => {
                            e.stopPropagation();
                            console.log('🖼️ Clique na imagem:', imageUrl);
                            onImageClick?.(imageUrl);
                        }}
                        loading="lazy"
                    />
                    <div className="vpmr-zoom-hint">
                        <ZoomIn size={14} strokeWidth={2} />
                        <span>Clique para ampliar</span>
                    </div>
                </div>
            )}

            {/* ✅ ÁUDIO - PLAYER GRAIA COMPACTO - só do Cloudinary */}
            {isCloudinaryAudio && (
                <div className="vpmr-audio-wrapper">
                    <GraiaAudioPlayer audioUrl={audioUrl} compact />
                </div>
            )}
        </div>
    );
};